import { logoApple, logoGooglePlaystore } from 'ionicons/icons'
import { Button, Content, Header, Icon, Modal, Title, Toolbar } from '@/ui'
import { APP_STORE_LINKS } from '@/config/appStoreLinks'
import { detectMobileStorePlatform } from '@/utils/appDownloadPrompt'
import './AppDownloadPromptModal.css'

export interface AppDownloadPromptModalProps {
  isOpen?: boolean
  onDismiss?: () => void
}

const storePlatform = detectMobileStorePlatform()

function openStore (platform: 'ios' | 'android') {
  const url = platform === 'android' ? APP_STORE_LINKS.android : APP_STORE_LINKS.ios
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function AppDownloadPromptModal ({ isOpen = false, onDismiss }: AppDownloadPromptModalProps) {
  const showIos = !storePlatform || storePlatform === 'ios'
  const showAndroid = !storePlatform || storePlatform === 'android'

  const onContinueWeb = () => {
    onDismiss?.()
  }

  return (
    <Modal isOpen={isOpen} onDidDismiss={onContinueWeb} className="c-app-download-prompt-modal" ariaLabel="Get the app">
      <Header>
        <Toolbar>
          <Title>Get the app</Title>
        </Toolbar>
      </Header>
      <Content padding>
        <div className="app-dl-modal">
          <p className="app-dl-lead">
            Download Nova Adult Hockey for check-in, reminders, and a better mobile
            experience.
          </p>

          {showIos && (
            <Button
              expand="block"
              color="primary"
              className="app-dl-store-btn"
              onClick={() => openStore('ios')}
            >
              <Icon slot="start" icon={logoApple} />
              App Store
            </Button>
          )}

          {showAndroid && (
            <Button
              expand="block"
              color="primary"
              className="app-dl-store-btn"
              onClick={() => openStore('android')}
            >
              <Icon slot="start" icon={logoGooglePlaystore} />
              Google Play
            </Button>
          )}

          <Button
            expand="block"
            fill="clear"
            color="medium"
            className="app-dl-skip"
            onClick={onContinueWeb}
          >
            Continue on web
          </Button>
        </div>
      </Content>
    </Modal>
  )
}
